import { Fragment } from 'react'
import { nest } from 'recompose'

import intl from './intl'
import store from './store'
import persist from './persist'
import router from './router'

export default nest(store, persist, intl, router, Fragment)
